module.exports = __webpack_public_path__ + "static/media/Akkurat.4ff4b91a.ttf";